import { type IAdminHeaderTopLayoutProps } from '@framework/theme/admin/AdminHeaderTopLayout.tsx';
import { FrontHeaderTopLayout } from '../front/FrontHeaderTopLayout.tsx';

/**
 * Fascia in alto della pagina che contiene il logo,
 * il menu principale, il menu delle notifiche e quello dell'utente.
 */
export function AdminHeaderTopLayout(props: IAdminHeaderTopLayoutProps) {
  return <FrontHeaderTopLayout {...props} />;
}
